import React from 'react';
import PropTypes from 'prop-types';
import { SummaryDetail, SummaryCategory, SummaryGroupWrapper } from './css';

const FormSummaryRow = ({ label, value, isDollarRemove, convertBoolValueToString }) =>
  ((!!value && value !== 'Null') || typeof value === 'number') && (
    <SummaryGroupWrapper>
      <SummaryCategory>
        <span className="frg-body-font-14px">{label}</span>
      </SummaryCategory>
      <SummaryDetail>
        <span className="frg-body-font-14px">
          {Array.isArray(value) && value.length > 0
            ? value.map(item =>
                typeof item === 'object' ? (
                  Object.keys(item).map(itemKey => (
                    <div key={`formSummaryRowItem${itemKey}`}>
                      {item[itemKey]}{' '}
                    </div>
                  ))
                ) : (
                  <div>{isDollarRemove ? item : `$${item}`}</div>
                )
              )
            : convertBoolValueToString && typeof value === "boolean" 
            ? value 
              ? "Yes" 
              : "No" 
            : value}
        </span>
      </SummaryDetail>
      <div className="clear"></div>
    </SummaryGroupWrapper>
  );

FormSummaryRow.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string,
  isDollarRemove: PropTypes.bool,
  convertBoolValueToString: PropTypes.bool
};

FormSummaryRow.defaultProps = {
  value: '',
  isDollarRemove: false,
  convertBoolValueToString: false,
};
export default FormSummaryRow;
